// extracted by mini-css-extract-plugin
export default {"icon":"WSIconList-component-module_icon-nBV3g"};